<template></template>

<script>
const CoreFooter = {
    name: 'CoreFooter',
    data: function() {
        return {};
    }
};
export default CoreFooter;

</script>

<style></style>


// WEBPACK FOOTER //
// footer.vue?952eb096